import { Vue, prop } from 'vue-class-component';
import 'vueperslides/dist/vueperslides.css';
import { Icon, IconNames } from '@/components/icon';
import styles from './styles.module.scss';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const { VueperSlides, VueperSlide } = require('vueperslides');

class CarouselProps {
	slides = prop<{ image: string }[]>({ default: [] })


	fractions = prop<boolean>({ default: true })

	progress = prop<boolean>({ default: false })

	fixedHeight = prop<string>({ default: undefined })

	arrowsOutside = prop<boolean>({ default: true })

	slideMultiple = prop<boolean>({ default: true })

	bulletsOutside = prop<boolean>({ default: true })
}
export class Carousel extends Vue.with(CarouselProps) {
	render() {
		const buttonSlot = {
			bullets: () => <Icon name={ IconNames.camera } size={ 30 } color={ '#888' }/>,
		};

		return (
			<VueperSlides
				class={ [styles.vueperslides, 'no-shadow'] }
				fixedHeight={ this.fixedHeight }
				progress={ this.progress }
				arrowsOutside={ this.arrowsOutside}
				bulletsOutside={this.bulletsOutside}
				fractions={ this.fractions }
				v-slots={ buttonSlot }
			>
				{
					this.slides.map(slide => <VueperSlide image={ slide.image }/>)
				}
			</VueperSlides>
		);
	}
}
